import React from "react";

const Forbidden: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          width: "100%",
          background: "#fff",
          borderRadius: "24px",
          padding: "60px 40px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        {/* 403 Icon */}
        <div
          style={{
            fontSize: "60px",
            fontWeight: "bold",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "10px",
            lineHeight: "1",
          }}
        >
         Link Inactive
        </div>

        {/* Title */}
       

        {/* Description */}
        <p
          style={{
            fontSize: "18px",
            color: "#666",
            marginBottom: "40px",
            lineHeight: "1.6",
          }}
        >
          Your link is no longer active. This usually happens if the order has been completed, the link has expired, or it hasn't been verified yet.
          <br /><br />
          Please contact Decorative Stone Solutions for assistance.
        </p>



        {/* Decorative Elements */}
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                opacity: 0.3 + (i * 0.15),
                animation: `pulse 2s ease-in-out ${i * 0.2}s infinite`,
              }}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

export default Forbidden;


